import { render, staticRenderFns } from "./PopupDivisionCountGraph.vue?vue&type=template&id=0860faf3&scoped=true"
import script from "./PopupDivisionCountGraph.vue?vue&type=script&lang=js"
export * from "./PopupDivisionCountGraph.vue?vue&type=script&lang=js"
import style0 from "./PopupDivisionCountGraph.vue?vue&type=style&index=0&id=0860faf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0860faf3",
  null
  
)

export default component.exports